export const CHAT_TRANSCRIPT_SENT = 'CHAT_TRANSCRIPT_SENT';